import { render, staticRenderFns } from "./MarketingActivities.vue?vue&type=template&id=7b3998e0&scoped=true&"
import script from "./MarketingActivities.vue?vue&type=script&lang=js&"
export * from "./MarketingActivities.vue?vue&type=script&lang=js&"
import style0 from "./MarketingActivities.vue?vue&type=style&index=0&id=7b3998e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3998e0",
  null
  
)

export default component.exports